import { InitialEventState } from "../components/resource/ResourceBookingDraftContext"
import { OrderContextState } from "../mainForm/helpers"
import { UserDetailsProps } from "../orderOnBehalf/OrderOnBehalfFlow"

export const defaultOrderContextState: OrderContextState = {
    mode: "create",
    orderId: undefined,
}

export const defaultUserDetailsState: UserDetailsProps = {
    companyId: undefined,
    companyGroupId: undefined,
    selectedUserId: undefined,
    selectedUserName: undefined,
}

export const defaultInitialEventState: InitialEventState = {
    event: null,
    initValues: null,
    isUpdated: false,
}
